import angular = require("angular");
import {Config} from "../config";
import {SessionService} from "../services/session";

export class HostPromotionController {

  static $inject = ["session", "$location"];

  constructor(
    public session: SessionService,
    private location
  ) {

    if (this.session.isHost()) {
      this.location.url(this.session.getLandingPage());
    }
  }

  promote() {
    if (this.session.isOnward()){
      this.session.requestHost().then(() => {
        this.location.url(this.session.getLandingPage());
      });
    } else {
      this.session.requestHost().then(() => {
        return this.session.autoPromoteToHost()
          .then((response) => {
            this.location.url(Config.manage + "/" + Config.hosted);
            this.location.replace();
          });
      });
    }

  }

}



/** WEBPACK FOOTER **
 ** ./src/scripts/controllers/hostPromotion.ts
 **/